import config from "../../config/config";
import {toastr} from "react-redux-toastr";

export const SET_ADDRESS_FIELDS = 'SET_ADDRESS_FIELDS';
export const REQUEST_COUNTRIES = 'REQUEST_COUNTRIES';
export const RECEIVE_COUNTRIES = 'RECEIVE_COUNTRIES';

export const ADDRESS_FIRSTNAME = 'firstName';
export const ADDRESS_LASTNAME = 'lastName';
export const ADDRESS_PHONE_COUNTRY = 'countryPhoneCode';
export const ADDRESS_PHONE = 'phone';
export const ADDRESS_EMAIL = 'email';
export const ADDRESS_IS_JURIDIC = 'isJuridic';

export const ADDRESS_COMPANY = 'companyName';
export const ADDRESS_COMPANY_INN = 'companyInn';
export const ADDRESS_COMPANY_KPP = 'companyKpp';
export const ADDRESS_COMPANY_OGRN = 'companyOgrn';
export const ADDRESS_COMPANY_CHIEF_NAME = 'companyChiefName';
export const ADDRESS_COMPANY_CONTACT_NAME = 'companyContactName';
export const ADDRESS_COMPANY_JOB_TITLE = 'companyJobTitle';
export const ADDRESS_COMPANY_SCOPE = 'companyScope';
export const ADDRESS_COMPANY_LEGAL_ADDR = 'companyLegalAddress';
export const ADDRESS_COMPANY_POST_ADDR = 'companyPostAddress';

export const requestCountries = () => ({
    type: REQUEST_COUNTRIES,
});

export const receiveCountries = (data) => ({
    type: RECEIVE_COUNTRIES,
    data,
});

const process_countries_api_error = (json, dispatch) => {
    dispatch(receiveCountries([]));
    toastr.error('Ошибка сервера: ' + String(json.code) + '. ' + json.message);
};

export const fetchCounties = () => (dispatch) => {
    dispatch(requestCountries());

    return fetch(config.API_COUNTRIES_URL)
        .then((response) => response.json())
        .then((json) => {
            if (json.code === 200)
                dispatch(receiveCountries(json.data));
            else
                process_countries_api_error(json, dispatch);
        })
        .catch( (ex) => toastr.error('Ошибка запроса: ' + String(ex)) );
};

export const setAddressFields = (data) => ({
    type: SET_ADDRESS_FIELDS,
    data,
});

export const getFormDataForAPI = (fields, languageString = 'ru') => {
    const isJuridic = fields[ADDRESS_IS_JURIDIC];
    const billingKey = languageString === 'ru' ? 'billing' : 'billing_en';

    const baseData = {
        [languageString === 'ru' ? 'name' : 'name_en']: isJuridic
            ? fields[ADDRESS_COMPANY]
            : `${fields[ADDRESS_FIRSTNAME]} ${fields[ADDRESS_LASTNAME]}`,
        [billingKey]: {
            first_name: fields[ADDRESS_FIRSTNAME] || '',
            last_name: fields[ADDRESS_LASTNAME] || '',
            phone_country: fields[ADDRESS_PHONE_COUNTRY] || '',
            phone: fields[ADDRESS_PHONE] || '',
            email: fields[ADDRESS_EMAIL] || '',
            is_juridic: isJuridic,
        },
    };

    if (isJuridic) {
        baseData[billingKey] = {
            ...baseData[billingKey],
            company: fields[ADDRESS_COMPANY] || '',
            company_chief_name: fields[ADDRESS_COMPANY_CHIEF_NAME] || '',
            company_contact_name: fields[ADDRESS_COMPANY_CONTACT_NAME] || '',
            company_ogrn: fields[ADDRESS_COMPANY_OGRN] || '',
            company_kpp: fields[ADDRESS_COMPANY_KPP] || '',
            company_inn: fields[ADDRESS_COMPANY_INN] || '',
            company_job_title: fields[ADDRESS_COMPANY_JOB_TITLE] || '',
            company_scope: fields[ADDRESS_COMPANY_SCOPE] || '',
            company_legal_address: fields[ADDRESS_COMPANY_LEGAL_ADDR] || '',
            company_post_address: fields[ADDRESS_COMPANY_POST_ADDR] || '',
        };
    }

    return baseData;
};

export const setFieldsFromUserData = (userData) => {
    return {
        [ADDRESS_FIRSTNAME]: userData?.first_name || '',
        [ADDRESS_LASTNAME]: userData?.last_name || '',
        [ADDRESS_PHONE_COUNTRY]: userData?.phone_country || 'RU',
        [ADDRESS_PHONE]: userData?.phone || '',
        [ADDRESS_EMAIL]: userData?.email || '',
        [ADDRESS_IS_JURIDIC]: userData?.is_juridic === "true" || userData?.is_juridic === true,
        [ADDRESS_COMPANY]: userData?.company || '',
        [ADDRESS_COMPANY_INN]: userData?.company_inn || '',
        [ADDRESS_COMPANY_KPP]: userData?.company_kpp || '',
        [ADDRESS_COMPANY_OGRN]: userData?.company_ogrn || '',
        [ADDRESS_COMPANY_CHIEF_NAME]: userData?.company_chief_name || '',
        [ADDRESS_COMPANY_CONTACT_NAME]: userData?.company_contact_name || '',
        [ADDRESS_COMPANY_JOB_TITLE]: userData?.company_job_title || '',
        [ADDRESS_COMPANY_SCOPE]: userData?.company_scope || '',
        [ADDRESS_COMPANY_LEGAL_ADDR]: userData?.company_legal_address || '',
        [ADDRESS_COMPANY_POST_ADDR]: userData?.company_post_address || '',
    };
};